





































































































































































import Vue from 'vue'
import {
  Region,
  Params,
  Subregion,
  VueForm,
  Iterable,
  SubRegionCrud,
} from '@/utils/interfaces'
import RegionDialog from '../Messengers/RegionDialog.vue'
import Card from '@/components/Card.vue'
import { TranslateResult } from 'vue-i18n'
import { getSubregions } from '@/api/Address/address'
import Autocomplete from '@/components/Autocomplete.vue'
import { SubRegionTariff } from '@/utils/interfaces/remittance.interface'
import ActionButton from '@/components/ActionButton.vue'
import { number } from '@/utils/validators'

export default Vue.extend({
  name: 'tariff-settings',
  components: {
    appRegionDialog: RegionDialog,
    appCard: Card,
    appAutocomplete: Autocomplete,
    appActionButton: ActionButton,
  },
  data() {
    return {
      subregion: null as null | Subregion,
      rules: {
        required: (v: number): TranslateResult | boolean =>
          !!v || v === 0 || this.$t('field-required'),
        number: (v: string): TranslateResult | boolean =>
          number(v) || this.$t('validation.must-be-a-number'),
      },
      crud: {
        min_commission: 0,
        percent_commission: 0,
        per_region: [] as SubRegionTariff[],
      } as Iterable,
      regionDialog: false,
      regions: [] as Region[],
      getSubregions: (params: Params) =>
        getSubregions({ ...params, region: this.$data.regions[0].id | 0 }),
      defaultCrud: {},
    }
  },
  computed: {
    isMovil(): boolean {
      return this.$vuetify.breakpoint.xs
    },
  },
  methods: {
    onRegionsSelected(payload: Region[]): void {
      if (this.regions[0] && this.regions[0] !== payload[0]) {
        this.crud.per_region = []
      }
      this.regions = payload
    },
    onDelete(i: number) {
      this.crud.per_region.splice(i, 1)
    },
    validate() {
      if (!this.regions.length) {
        this.$store.commit(
          'snackbar/message',
          this.$t('validation.region-info-is-missing'),
        )
        this.$store.commit('snackbar/title', 'Error')
        this.$store.commit('snackbar/model', true)
        return false
      }
      return (this.$refs.form as VueForm).validate()
    },
    getData() {
      const region = this.regions[0] || { name: '', id: 0 }
      return { ...this.crud, region: region.id, region_name: region.name }
    },
    setData(item: Iterable) {
      if (item) {
        this.crud.min_commission = item.min_commission
        this.crud.percent_commission = item.percent_commission
        this.crud.per_region = [...item.per_region]
        ;(this.$refs.regionDialog as Vue & {
          setRegions: (region: number[]) => void
        }).setRegions([item.region])
      } else {
        this.crud = JSON.parse(JSON.stringify(this.defaultCrud))
        this.regions = []
        ;(this.$refs.form as VueForm).resetValidation()
      }
    },
    onAddSubregion(): void {
      if (
        this.subregion &&
        this.crud.per_region.findIndex((item: SubRegionCrud) => {
          if (this.subregion) {
            return item.subregion === this.subregion.id
          }
          return false
        }) === -1
      ) {
        this.crud.per_region.push({
          subregion: this.subregion.id,
          subregion_name: this.subregion.name,
          min_commission: 0,
          percent_commission: 0,
          is_active: true,
        })
      }
    },
  },
  created() {
    this.defaultCrud = JSON.parse(JSON.stringify(this.crud))
  },
})
